namespace TabAurous.Production {
    export interface JobWorkReceiptForm {
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        PartyId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        DepartmentId: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        EmployeeId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        ItemDetails: JobWorkReceiptItemsEditor;
        TaxDetails: JobWorkReceiptTaxEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        CCTaxAmount: Serenity.DecimalEditor;
        CCRoundOff: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class JobWorkReceiptForm extends Serenity.PrefixedContext {
        static formKey = 'Production.JobWorkReceipt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JobWorkReceiptForm.init)  {
                JobWorkReceiptForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;
                var w5 = JobWorkReceiptItemsEditor;
                var w6 = JobWorkReceiptTaxEditor;

                Q.initFormType(JobWorkReceiptForm, [
                    'TransDate', w0,
                    'VoucherTypeId', w1,
                    'VoucherNo', w2,
                    'PartyId', w3,
                    'LedgerName', w2,
                    'DepartmentId', w3,
                    'UserId', w3,
                    'CurrencyId', w3,
                    'ExchRate', w4,
                    'EmployeeId', w1,
                    'RefVoucherId', w1,
                    'RefTransId', w2,
                    'ItemDetails', w5,
                    'TaxDetails', w6,
                    'Pieces', w1,
                    'Weight', w4,
                    'NetWeight', w4,
                    'NetAmount', w4,
                    'CCNetAmount', w4,
                    'TaxAmount', w4,
                    'CCTaxAmount', w4,
                    'CCRoundOff', w4,
                    'GrossAmount', w4,
                    'CCGrossAmount', w4,
                    'CompanyId', w1,
                    'FinancialYearId', w1
                ]);
            }
        }
    }
}
